import {
  contactUsApi,
  getBlogCategoriesApi,
  getBlogsApi,
  getBlogsByCategoryApi,
  getClientsApi,
  getContactSectionApi,
  getPageDataApi,
  getProjectsApi,
  getProjectTypesApi,
  getSectionDataApi,
  getServicesApi,
  getSettingsApi,
  getSingleBlogApi,
  getSingleCategoryApi,
  getSocialsApi,
  subscribeNewsletterApi,
} from "@/api/settings";
import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  contactUsFailure,
  contactUsSuccess,
  getBlogCategoriesFailure,
  getBlogCategoriesSuccess,
  getBlogsByCategoryFailure,
  getBlogsByCategorySuccess,
  getBlogsFailure,
  getBlogsSuccess,
  getClientsFailure,
  getClientsSuccess,
  getContactSectionFailure,
  getContactSectionSuccess,
  getPageDataFailure,
  getPageDataSuccess,
  getProjectsFailure,
  getProjectsSuccess,
  getProjectTypesFailure,
  getProjectTypesSuccess,
  getSectionDataFailure,
  getSectionDataSuccess,
  getServicesFailure,
  getServicesSuccess,
  getSettingsFailure,
  getSettingsSuccess,
  getSingleCategoryFailure,
  getSingleCategorySuccess,
  getSingleBlogFailure,
  getSingleBlogSuccess,
  getSocialsFailure,
  getSocialsSuccess,
  subscribeNewsletterFailure,
  subscribeNewsletterSuccess,
  loadMoreBlogsSuccess,
  loadMoreBlogsFailure,
} from "./actions";
import {
  CONTACT_US,
  GET_BLOG_CATEGORIES,
  GET_BLOGS,
  GET_BLOGS_BY_CATEGORY,
  GET_CLIENTS,
  GET_CONTACT_SECTION,
  GET_PAGE_DATA,
  GET_PROJECTS,
  GET_PROJECT_TYPES,
  GET_SECTION_DATA,
  GET_SERVICES,
  GET_SETTINGS,
  GET_SINGLE_BLOG,
  GET_SINGLE_CATEGORY,
  GET_SOCIALS,
  LOAD_MORE_BLOGS,
  SUBSCRIBE_NEWSLETTER,
} from "./actionTypes";

function* getPageDataSaga({ payload }) {
  try {
    const { data } = yield call(getPageDataApi, payload);
    yield put(getPageDataSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getPageDataFailure(error));
  }
}

// ==================================================
// ==================================================

function* getSettingsSaga({ payload }) {
  try {
    const { data } = yield call(getSettingsApi, payload);
    yield put(getSettingsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSettingsFailure(error));
  }
}

// ==================================================
// ==================================================

function* contactUsSaga({ payload }) {
  try {
    const { data, success, message } = yield call(contactUsApi, payload);
    yield put(contactUsSuccess(data));
    if (success) {
      yield payload.toast.success(
        message || payload?.formatMessage({ id: "contactUsSuccess" }),
      );
      yield payload.reset({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });

      if (payload.router) {
        yield payload?.router?.push("/thanks");
      }
    }
  } catch (error) {
    console.log(error);
    yield put(contactUsFailure(error));
    yield payload.toast.error(error.response?.data?.message || error);
  }
}

// ==================================================
// ==================================================

function* getSectionDataSaga({ payload }) {
  try {
    const { data } = yield call(getSectionDataApi, payload);
    yield put(getSectionDataSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSectionDataFailure(error));
  }
}

// ==================================================
// ==================================================

function* getServicesSaga({ payload }) {
  try {
    const { data } = yield call(getServicesApi, payload);
    yield put(getServicesSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getServicesFailure(error));
  }
}

// ==================================================
// ==================================================

function* getProjectsSaga({ payload }) {
  try {
    const { data } = yield call(getProjectsApi, payload);
    yield put(getProjectsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getProjectsFailure(error));
  }
}

function* getProjectTypesSaga({ payload }) {
  try {
    const { data } = yield call(getProjectTypesApi, payload);
    yield put(getProjectTypesSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getProjectTypesFailure(error));
  }
}

// ==================================================
// ==================================================

function* getBlogsSaga({ payload }) {
  try {
    const { data } = yield call(getBlogsApi, payload);
    yield put(getBlogsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getBlogsFailure(error));
  }
}

// ==================================================
// ==================================================

function* getSingleBlogSaga({ payload }) {
  try {
    const { data } = yield call(getSingleBlogApi, payload);
    yield put(getSingleBlogSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(
      getSingleBlogFailure(
        error?.response?.data?.message || error?.message || "Failed to fetch blog",
      ),
    );
  }
}

// ==================================================
// ==================================================

function* subscribeNewsletterSaga({ payload }) {
  try {
    const { data, success, message } = yield call(
      subscribeNewsletterApi,
      payload,
    );
    yield put(subscribeNewsletterSuccess(data));
    if (success) {
      yield payload.toast.success(
        message || payload?.formatMessage({ id: "subscribeNewsletterSuccess" }),
      );
      yield payload.reset({
        email: "",
      });
    }
  } catch (error) {
    console.log(error);
    yield put(subscribeNewsletterFailure(error));
    yield payload.toast.error(error.response?.data?.message || error);
  }
}

// ==================================================
// ==================================================

function* getSocialsSaga({ payload }) {
  try {
    const { data } = yield call(getSocialsApi, payload);
    yield put(getSocialsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSocialsFailure(error));
  }
}

// ==================================================
// ==================================================

function* getClientsSaga({ payload }) {
  try {
    const { data } = yield call(getClientsApi, payload);
    yield put(getClientsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getClientsFailure(error));
  }
}

// ==================================================
// ==================================================

function* getContactSectionSaga({ payload }) {
  try {
    const { data } = yield call(getContactSectionApi, payload);
    yield put(getContactSectionSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getContactSectionFailure(error));
  }
}

// ==================================================
// ==================================================

function* getBlogCategoriesSaga({ payload }) {
  try {
    const { data } = yield call(getBlogCategoriesApi, payload);
    yield put(getBlogCategoriesSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getBlogCategoriesFailure(error));
  }
}

// ==================================================
// ==================================================

function* getSingleCategorySaga({ payload }) {
  try {
    const { data } = yield call(getSingleCategoryApi, payload);
    yield put(getSingleCategorySuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleCategoryFailure(error));
  }
}

// ==================================================
// ==================================================

function* getBlogsByCategorySaga({ payload }) {
  try {
    const { data } = yield call(getBlogsByCategoryApi, payload);
    yield put(getBlogsByCategorySuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getBlogsByCategoryFailure(error));
  }
}

// ==================================================
// ==================================================

function* loadMoreBlogsSaga({ payload }) {
  try {
    const { data } = yield call(getBlogsApi, payload);
    yield put(loadMoreBlogsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(loadMoreBlogsFailure(error));
  }
}

// ==================================================
// ==================================================

export function* watchGetPageData() {
  yield takeEvery(GET_PAGE_DATA, getPageDataSaga);
}

export function* watchGetSettings() {
  yield takeEvery(GET_SETTINGS, getSettingsSaga);
}

export function* watchContactUs() {
  yield takeEvery(CONTACT_US, contactUsSaga);
}

export function* watchGetSectionData() {
  yield takeEvery(GET_SECTION_DATA, getSectionDataSaga);
}

export function* watchGetServices() {
  yield takeEvery(GET_SERVICES, getServicesSaga);
}

export function* watchGetProjects() {
  yield takeEvery(GET_PROJECTS, getProjectsSaga);
}

export function* watchGetProjectTypes() {
  yield takeEvery(GET_PROJECT_TYPES, getProjectTypesSaga);
}

export function* watchGetBlogs() {
  yield takeEvery(GET_BLOGS, getBlogsSaga);
}

export function* watchGetSingleBlog() {
  yield takeEvery(GET_SINGLE_BLOG, getSingleBlogSaga);
}

export function* watchSubscribeNewsletter() {
  yield takeEvery(SUBSCRIBE_NEWSLETTER, subscribeNewsletterSaga);
}

export function* watchGetSocials() {
  yield takeEvery(GET_SOCIALS, getSocialsSaga);
}

export function* watchGetClients() {
  yield takeEvery(GET_CLIENTS, getClientsSaga);
}

export function* watchGetContactSection() {
  yield takeEvery(GET_CONTACT_SECTION, getContactSectionSaga);
}

export function* watchGetBlogCategories() {
  yield takeEvery(GET_BLOG_CATEGORIES, getBlogCategoriesSaga);
}

export function* watchGetSingleCategory() {
  yield takeEvery(GET_SINGLE_CATEGORY, getSingleCategorySaga);
}

export function* watchGetBlogsByCategory() {
  yield takeEvery(GET_BLOGS_BY_CATEGORY, getBlogsByCategorySaga);
}

export function* watchLoadMoreBlogs() {
  yield takeEvery(LOAD_MORE_BLOGS, loadMoreBlogsSaga);
}

// ==================================================
// ==================================================

function* settingsSaga() {
  yield all([fork(watchGetPageData)]);
  yield all([fork(watchGetSettings)]);
  yield all([fork(watchContactUs)]);
  yield all([fork(watchGetSectionData)]);
  yield all([fork(watchGetServices)]);
  yield all([fork(watchGetProjects)]);
  yield all([fork(watchGetProjectTypes)]);
  yield all([fork(watchGetBlogs)]);
  yield all([fork(watchGetSingleBlog)]);
  yield all([fork(watchSubscribeNewsletter)]);
  yield all([fork(watchGetSocials)]);
  yield all([fork(watchGetClients)]);
  yield all([fork(watchGetContactSection)]);
  yield all([fork(watchGetBlogCategories)]);
  yield all([fork(watchGetSingleCategory)]);
  yield all([fork(watchGetBlogsByCategory)]);
  yield all([fork(watchLoadMoreBlogs)]);
}

export default settingsSaga;
